import { useState } from 'react';
import { Button, Chip, Stack, Typography } from '@mui/material';
import { useGetRolesQuery } from '../../api/fileStorageApi';
import { BaseDialog } from '../common';

type RolesDialogProps = {
  open: boolean;
  filesKeys: string[];
  initialSelectedRoles?: string[];
  onClose: () => void;
  onSubmit: (roles: string[]) => void;
};

export const RolesDialog = ({
  open,
  filesKeys,
  initialSelectedRoles = [],
  onClose,
  onSubmit,
}: RolesDialogProps) => {
  const { data: availableRoles = [] } = useGetRolesQuery();
  const [selected, setSelected] = useState<string[]>(() => initialSelectedRoles);
  const toggle = (role: string) =>
    setSelected((prev) => (prev.includes(role) ? prev.filter((r) => r !== role) : [...prev, role]));

  const handleClose = () => {
    onClose();
  };

  const handleSubmit = () => {
    onSubmit(selected);
  };

  return (
    <BaseDialog
      open={open}
      onClose={handleClose}
      title={`Edit roles (${filesKeys.length} item${filesKeys.length !== 1 ? 's' : ''})`}
      actions={
        <>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>
            Save
          </Button>
        </>
      }
    >
      <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mt: 0.5 }}>
        {availableRoles.map((role) => (
          <Chip
            key={role}
            label={role}
            clickable
            color={selected.includes(role) ? 'primary' : 'default'}
            onClick={() => toggle(role)}
            size="small"
          />
        ))}
        {availableRoles.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            No roles available
          </Typography>
        )}
      </Stack>
    </BaseDialog>
  );
};
